import { DatePicker, Form, Input, Space } from 'antd';
import styles from '../../Dashboard/index.module.less';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
import CustomModal from '@/common/CustomModal';
import { CalendarOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { getFormattedDateToSend, getNextBusinessDate } from 'utilities/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { rescheduleFollowUp, selectFollowUpSlice } from '../redux/slice';
import moment from 'moment';

const options = ['Tomorrow', 'After 3 Days', 'Next Week', 'Two Weeks'];

export default function RescheduleModal({ isOpen, setIsOpen, onAssign, data }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { rescheduleFollowUpLoading } = useSelector(selectFollowUpSlice);

  const [selectedOption, setSelectedOption] = useState(options[0]);

  const toggleOption = (option) => {
    setSelectedOption(option);
    // const currentDate = data?.followup_date;
    // form.setFieldsValue({
    //   new_follow_up_date: getNextBusinessDate(currentDate, option)
    // });
    const currentDate = moment(); // use today's date
    form.setFieldsValue({
      new_follow_up_date: getNextBusinessDate(currentDate, option)
    });
  };

  const handleClose = () => {
    setIsOpen(null);
    form.resetFields();
    setSelectedOption(options[0]);
  };

  useEffect(() => {
    form.setFieldsValue({
      current_follow_up_date: moment(data?.followup_date),
      // new_follow_up_date: getNextBusinessDate(data?.followup_date, options[0]),
      new_follow_up_date: getNextBusinessDate(moment(), options[0]),
      reschedule_reason: ''
    });
  }, [isOpen]);

  const onFinish = (values) => {
    const payload = {
      ...values,
      id: isOpen,
      current_follow_up_date: getFormattedDateToSend(
        values?.current_follow_up_date
      ),
      new_follow_up_date: getFormattedDateToSend(values.new_follow_up_date)
    };
    dispatch(rescheduleFollowUp(payload)).then((res) => {
      if (res?.payload?.success) {
        handleClose();
        onAssign();
      }
    });
  };

  return (
    <CustomModal
      visible={isOpen}
      footer={null}
      className={`!w-full sm:!w-[70%] md:!w-[50%] lg:!w-[45%] xl:!w-[35%] ${styles.customModal}`}
      closable={false}
      centered
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        // onValuesChange={handleFormValuesChange}
      >
        <h3 className={styles.mainTitle} style={{ fontWeight: 'bold' }}>
          Reschedule follow-up
        </h3>

        <div className={'!mt-4 flex flex-col gap-2'}>
          <FormItem
            label="Current follow-up date"
            name="current_follow_up_date"
            className={styles.customLable}
          >
            <DatePicker
              disabled
              style={{ width: '100%' }}
              placeholder="Select date"
            />
          </FormItem>

          <div className="flex flex-col gap-0">
            <label
              style={{ fontFamily: 'SFProText Bold' }}
              className=" font-bold !text-xs !leading-none text-[#263238] mb-1"
            >
              New follow-up date
            </label>
            <Space>
              {options.map((option) => {
                const isSelected = selectedOption === option;
                return (
                  <div
                    key={option}
                    style={{
                      fontFamily: 'SFProText Bold',
                      border: '1px solid #dddddd',
                      borderRadius: '4px',
                      paddingBlock: '4px',
                      paddingInline: '6px',
                      fontSize: '12px',
                      cursor: isSelected ? 'not-allowed' : 'pointer',
                      backgroundColor: isSelected ? '#0653fa' : 'transparent',
                      color: isSelected ? 'white' : 'black'
                    }}
                    onClick={() => toggleOption(option)}
                  >
                    {option}
                  </div>
                );
              })}
            </Space>

            <FormItem
              label=""
              name="new_follow_up_date"
              rules={[
                { required: true, message: 'New follo-up date is required' }
              ]}
              className={`mt-2 ${styles.customLable}`}
            >
              <DatePicker
                style={{ width: '100%' }}
                placeholder="Select date"
                disabledDate={(current) =>
                  current && current < moment().startOf('day')
                }
              />
            </FormItem>
          </div>

          <FormItem
            label="Reason for rescheduling"
            name="reschedule_reason"
            className={styles.customLable}
          >
            <Input.TextArea
              rows={3}
              placeholder="Why are you rescheduling this follow-up?"
            />
          </FormItem>
        </div>

        <FormItem className="text-center">
          <Space style={{ marginTop: '20px' }}>
            <CustomButton
              className={styles.inwardButton}
              onClick={() => handleClose()}
              type="primary"
              ghost
            >
              Cancel
            </CustomButton>
            <CustomButton
              className={styles.inwardButton}
              htmlType="submit"
              type="primary"
              icon={<CalendarOutlined />}
              loading={rescheduleFollowUpLoading}
            >
              Reschedule
            </CustomButton>
          </Space>
        </FormItem>
      </Form>
    </CustomModal>
  );
}
